import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import configReducer from './configSlice';
import loginReducer from '../login/loginSlice';
import langReducer from '../lang/langSlice';
import tokenReducer from '../tokenHandling/tokenSlice';
import appReducer from '../../data/appSlice';
import userReducer from '../../features/users/userSlice';
import { userApi } from '../../services/userApi';
import { assetsApi } from '../../services/assetsApi';
import { historicalApi } from '../../services/historicalApi';
import { nrtApi } from '../../services/nrtApi';
import errorReducer from '../../features/httpRequestFeedbackNotification/errorSlice';
import { dtcApi } from '../../services/dtcApi';
import { trendDataApi } from '../../services/trendDataApi';

export const store = configureStore({
    reducer: {
        config: configReducer,
        lang: langReducer,
        app: appReducer,
        user: userReducer,
        login: loginReducer,
        tokenHandling: tokenReducer,
        error: errorReducer,

        // Add the generated reducer as a specific top-level slice
        [userApi.reducerPath]: userApi.reducer,
        [historicalApi.reducerPath]: historicalApi.reducer,
        [assetsApi.reducerPath]: assetsApi.reducer,
        [nrtApi.reducerPath]: nrtApi.reducer,
        [dtcApi.reducerPath]: dtcApi.reducer,
        [trendDataApi.reducerPath]: trendDataApi.reducer,
    },

    // Adding the api middleware enables caching, invalidation, polling,
    // and other useful features of `rtk-query`.
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware().concat(
            historicalApi.middleware,
            assetsApi.middleware,
            nrtApi.middleware,
            dtcApi.middleware,
            trendDataApi.middleware
        ),
});

// Infer the `RootState` and `RootDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type RootDispatch = typeof store.dispatch;

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);
